<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">รายงานการเติมเครดิต</h1>
                    <p class="text-white pb-3 px-3">ดูรายงานการเติมเครดิตของคุณ</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-7">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-5">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-5">
                                                <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res" @click="funcHistoryTopUpWallet()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group
                                        v-if="!this.main_use_walletV2"
                                        id="input-group-1"
                                        label="ตัวกรอง"
                                        label-for="input-1"
                                        class="mb-0"
                                    >
                                        <select class="form-control" v-model="filterStatus">
                                            <option :value="status.key" v-for="status in dataStatus" :key="status.key">{{status.title}}</option>
                                        </select>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-2">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel
                                                :disabled="this.main_use_walletV2"
                                                :columns="columnsExcel"
                                                :getData="funcGetDataBranceExportExcel"
                                                name="ประวัติเติมเครดิต "
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                v-if="this.main_use_walletV2"
                                class="scroll-bar-pop"
                                empty-text="ไม่มีรายละเอียดการเติมเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :items="filterDataTopUp"
                                :fields="table_fields_wallet_v2"
                                :filter="filter"
                                :busy="busy"
                                show-empty
                                responsive
                                foot-clone
                                >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">
                                    {{ data.index+1 }}
                                </template>
                                <template slot="created_at" slot-scope="row">
                                    {{ row.item.created_at | dateFormat(main_use_walletV2) }}
                                </template>
                                <template slot="value" slot-scope="row">
                                    <span :class="{'text-success': true }">
                                        + {{ row.item.value | numFormat('0,0.00') }}
                                    </span>
                                </template>
                                <template slot="depositor_name" slot-scope="row">
                                    <span>
                                        {{ row.item.actor.name }}
                                    </span>
                                </template>
                                <template slot="receipt" slot-scope="row">
                                    <div class="text-center">
                                        <a href="#"
                                            v-if="row.item.receipt"
                                            size="sm"
                                            variant="info"
                                            @click="openReceipt(row.item.receipt)"
                                            :class="{ 'text-muted': loadingReceipts[row.item.receipt] }"
                                            style="text-decoration: none;"
                                            @mouseover="$event.target.style.textDecoration = 'underline'"
                                            @mouseout="$event.target.style.textDecoration = 'none'"
                                        >
                                            <i v-if="loadingReceipts[row.item.receipt]" class="fa fa-spinner fa-spin mr-1"></i>
                                            {{ row.item.receipt }}
                                        </a>
                                        <span v-else v-b-tooltip title="ระบบจะออกใบเสร็จในวันถัดไป">-</span>
                                    </div>
                                </template>
                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_created_at">&nbsp;</template>
                                <template slot="FOOT_transaction_id">&nbsp;</template>
                                <template slot="FOOT_credit">{{footerTotal.credit | numFormat('0,0.00')}}</template>
                                <template slot="FOOT_status">&nbsp;</template>
                                <template slot="FOOT_remark">&nbsp;</template>
                            </b-table>
                            <b-table
                                v-else
                                show-empty
                                responsive
                                empty-text="ไม่มีรายละเอียดการเติมเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :items="filterDataTopUp"
                                :fields="fields"
                                :filter="filter"
                                :busy="busy"
                                class="scroll-bar-pop"
                                foot-clone
                                >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                                <template slot="created_at" slot-scope="row">{{ row.item.created_at | dateFormat(main_use_walletV2) }}</template>
                                <template slot="credit" slot-scope="row">
                                    <span :class="{'text-success': row.item.status, 'text-pending': !row.item.status}">
                                        + {{ row.item.credit | numFormat('0,0.00') }} <i class="fa fa-clock fa-xs" v-if="!row.item.status" v-b-tooltip title="รอดำเนินการ"></i>
                                    </span>
                                </template>
                                <template slot="status" slot-scope="row">
                                    <b-badge :variant="statusPayment(row.item.status).color +' report'" >
                                        {{statusPayment(row.item.status).status}}
                                    </b-badge>
                                </template>
                                <template slot="receipt" slot-scope="row">
                                    <div class="text-center">
                                        <a href="#"
                                            v-if="row.item.receipt"
                                            size="sm"
                                            variant="info"
                                            @click="openReceipt(row.item.receipt)"
                                            :class="{ 'text-muted': loadingReceipts[row.item.receipt] }"
                                            style="text-decoration: none;"
                                            @mouseover="$event.target.style.textDecoration = 'underline'"
                                            @mouseout="$event.target.style.textDecoration = 'none'"
                                        >
                                            <i v-if="loadingReceipts[row.item.receipt]" class="fa fa-spinner fa-spin mr-1"></i>
                                            {{ row.item.receipt }}
                                        </a>
                                        <span v-else v-b-tooltip title="ระบบจะออกใบเสร็จในวันถัดไป">-</span>
                                    </div>
                                </template>
                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_created_at">&nbsp;</template>
                                <template slot="FOOT_transaction_id">&nbsp;</template>
                                <template slot="FOOT_credit">{{footerTotal.credit | numFormat('0,0.00')}}</template>
                                <template slot="FOOT_status">&nbsp;</template>
                                <!-- <template slot="FOOT_g">&nbsp;</template>
                                <template slot="FOOT_h">&nbsp;</template> -->
                                <template slot="FOOT_remark">&nbsp;</template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :value="pagination.currentPage"
                                    @input="changePage"
                                    align="right"
                                >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import 'moment-timezone/builds/moment-timezone-with-data';
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { statusPayment } from "@/axios/walletPayment.js"
import { dateLimitRanges } from "@/plugins/datePicker.js"
import { showErrorModal } from "@/components/modalNotification.js"; 

import Mixins from "./report_makeup";

export default {
    mixins: [Mixins],

    name: "historytopupwallet",
    components:{
        ExportExcel
    },
    data() {
        return {
            busy: false,
            loadingReceipts: {},
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            filter: null,
            filterStatus: null,
            dataStatus:[
                { key: null , title:'ดูสถานะทั้งหมด'},
                { key: '1' , title: 'สำเร็จ' },
                { key: '0' , title: 'รออนุมัติ' },
                { key: '-1' , title: 'ไม่อนุมัติ' }
            ],
            dataTopup:[],
            pagination:{
                totalPage: 1,
                totalItem: 0,
                currentPage: 1,
                perPage: 20
            },
            statusPayment: statusPayment,

            funcHistoryTopUpWallet: null,
            funcGetDataBranceExportExcel: null,

            tableFields: [],
            table_fields_wallet_v2: [
                {
                    key     : "index",
                    field   : "index",
                    label   : "#",
                    sortable: true
                },
                {
                    key     : "created_at",
                    field   : "created_at",
                    label   : "วันเวลาที่ทำรายการ",
                    sortable: true,
                    class   : "text-center"
                },
                {
                    key     : "id",
                    field   : "id",
                    label   : "เลขที่รายการ",
                    sortable: false,
                    class   : "text-center"
                },
                {
                    key     : "value",
                    field   : "value",
                    label   : "จำนวนเงิน",
                    sortable: false,
                    class   : "text-center"
                },
                {
                    key     : "depositor_name",
                    field   : "actor",
                    label   : "ผู้เติม",
                    sortable: false,
                    class   : "text-center"
                },
                {
                    key     : "remark",
                    field   : "remark",
                    label   : "หมายเหตุ",
                    sortable: true
                },
                {
                    key     : "receipt",
                    field   : "receipt",
                    label   : "เลขที่ใบเสร็จ",
                    sortable: false,
                    class   : "text-center"
                }
            ],
        }
    },
    filters: {
        dateFormat(date, use_walletV2) {
            if (use_walletV2) {
                // UTC to +07:00
                return moment(date, "YYYY-MM-DD HH:mm:ss")
                    .add(7, 'hours')
                    .format("DD/MM/YYYY HH:mm:ss");
            }

            return moment(date, "YYYY-MM-DD HH:mm:ss")
                .format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.assignFuncsByThemeName();

        this.funcHistoryTopUpWallet()
    },
    methods: {
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        changePage(i){
            if (this.pagination.currentPage == i) {
                return
            }

            this.pagination.currentPage = i
            this.funcHistoryTopUpWallet()
        },
        historyTopUpWallet(){
            this.busy = true;
            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
            this.$http
                .get(this.$API_URL + "/wallet/agent/transaction/info",{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            page: this.pagination.currentPage,
                            subject: this.wallet_subject_deposit,
                            date_start: dateStart,
                            date_end: dateEnd
                        }
                    }
                )
                .then(res => {
                    let data = res.data.data;
                    this.dataTopup = data.data
                    this.pagination.totalPage = data.total_page
                    this.pagination.totalItem = data.total_item
                    this.pagination.perPage = data.per_page
                    this.pagination.currentPage = data.page
                    this.busy = false;
                })
                .catch(() => {});
        },
        historyTopUpWalletV2(){
            this.busy = true;

            const start_date = moment(this.filters.startDate)
                .startOf('day')
                .subtract(7, 'hours')
                .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
            const end_date = moment(this.filters.endDate)
                .endOf('day')
                .subtract(7, 'hours')
                .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")

            this.$http
                .get(this.$API_URL + "/wallet_v2/agent/transaction/paginate/with-actor",{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            page       : this.pagination.currentPage,
                            limit      : this.pagination.perPage,
                            sort_option: 'updated_at:desc',
                            subject    : this.wallet_subject_deposit,
                            start_date : start_date,
                            end_date   : end_date
                        }
                    }
                )
                .then(res => {
                    const res_data       = res.data.data;
                    const res_data_items = [...res_data.items];

                    this.dataTopup = res_data_items;
                    this.pagination.currentPage = res_data.page;
                    this.pagination.perPage     = res_data.limit
                    this.pagination.totalPage   = res_data.total_pages
                    this.pagination.totalItem   = res_data.total_rows
                })
                .catch(() => {
                    this.dataTopup = [];
                })
                .finally(() => {
                    this.busy = false;
                });
        },

        async getDataBranceExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + "/wallet/agent/transaction/info",{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    subject: 'deposit',
                                    page: page++
                                }
                            }
                        )
                    )
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data.data)
                    })
                    resolve(dataExcel)
                })
            })
        },
        async getDataBranceExportExcelWalletV2() {
            return new Promise(resolve => {
                const ExcelTask = [];

                let iter_page = 1;
                const start_date = moment(this.filters.startDate)
                    .startOf('day')
                    .subtract(7, 'hours')
                    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
                const end_date = moment(this.filters.endDate)
                    .endOf('day')
                    .subtract(7, 'hours')
                    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

                for (let i = 0; i < this.pagination.totalPage; i++) {
                    const promise = this.$http
                        .get(this.$API_URL + "/wallet_v2/agent/transaction/paginate",{
                            headers: {
                                Token: localStorage.getItem("access_token")
                            },
                            params: {
                                page      : iter_page,
                                limit     : this.pagination.perPage,
                                subject   : this.wallet_subject_deposit,
                                start_date: start_date,
                                end_date  : end_date
                            }
                        });

                    ExcelTask.push({ promise, index: i });
                    iter_page++;
                }

                Promise.all(ExcelTask.map(p => p.promise)).then((res) => {
                    const sorted_res = ExcelTask.sort((a, b) => a.index - b.index)
                        .map(p => res[p.index]);

                    const data_excel = [];
                    for (const each_res of sorted_res) {
                        if (
                            each_res &&
                            each_res.data &&
                            each_res.data.data &&
                            each_res.data.data.items
                        ) {
                            const each_res_items = [...each_res.data.data.items];
                            for (const [index, item] of each_res_items.entries()) {
                                each_res_items[index]['transaction_id']     = item['id'];
                                each_res_items[index]['credit']             = item['value'];
                                each_res_items[index]['status']             = item['is_settled'] ? 1 : 0;
                                each_res_items[index]['accumulated_credit'] = item['balance'];
                                each_res_items[index]['available_credit']   = item['available_balance'];
                                each_res_items[index]['remark']             = item['remark'];
                                each_res_items[index]['receipt']            = item['receipt'];
                            }

                            data_excel.push(...each_res_items);
                        }
                    }

                    resolve(data_excel);
                })
            })
        },

        assignFuncsByThemeName() {
            if (this.main_use_walletV2) {
                this.funcHistoryTopUpWallet       = this.historyTopUpWalletV2;
                this.funcGetDataBranceExportExcel = this.getDataBranceExportExcelWalletV2;
            } else {
                this.funcHistoryTopUpWallet       = this.historyTopUpWallet;
                this.funcGetDataBranceExportExcel = this.getDataBranceExportExcel;
            }
        },
        openReceipt(receiptId) {
            this.$set(this.loadingReceipts, receiptId, true);
            this.$http
                .get(this.$API_URL + `/admin/receipt/${receiptId}/pdf`, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    responseType: 'blob'
                })
                .then(response => {
                    if (!response || !response.data || response.data.size === 0) {
                        throw new Error('Empty response data');
                    }
                    
                    if (response.data.type === 'application/json') {
                        const reader = new FileReader();
                        reader.onload = function() {
                            try {
                                const jsonResponse = JSON.parse(reader.result);
                                showErrorModal('ไม่สามารถดึงข้อมูลใบเสร็จได้');
                            } catch (e) {
                                showErrorModal('ไม่สามารถดึงข้อมูลใบเสร็จได้', e.message);
                            }
                        };
                        reader.readAsText(response.data);
                        return;
                    }

                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    
                    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        showErrorModal('ไม่พบใบเสร็จที่ต้องการ');
                    } else if (error.response && error.response.status === 401) {
                        showErrorModal('ไม่มีสิทธิ์เข้าถึงใบเสร็จ');
                    } else {
                        showErrorModal('ไม่สามารถดึงข้อมูลใบเสร็จได้');
                    }
                })
                .finally(() => {
                    this.$set(this.loadingReceipts, receiptId, false);
                });
        }
    },
    computed: {
        fields(){
            const fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true , class:"text-center" },
                { key: "transaction_id", field: "transaction_id", label: "เลขที่รายการ", sortable: true , class:"text-center" },
                { key: "credit", field: "credit", label: "จำนวนเครดิต", sortable: true , class:"text-center"},
                { key: "status", field: "status", label: "สถานะรายการ", sortable: true , class:"text-center" },
                // { key: "h", field: "h", label: "ช่องทาง", sortable: true },
                // { key: "l", field: "l", label: "ใบเสร็จการเติมเงิน", sortable: true },
                { key: "remark", field: "remark", label: "หมายเหตุ", sortable: true },
                { key: "receipt", field: "receipt", label: "เลขที่ใบเสร็จ", sortable: false, class: "text-center" }
            ]
            return fields
        },
        columnsExcel(){
            let columns =  [
                { field: "created_at", label: "วันเวลาที่ทำรายการ"  },
                { field: "transaction_id", label: "เลขที่รายการ"  },
                { field: "credit", label: "จำนวนเครดิต" },
                {
                    field: "status",
                    label: "สถานะรายการ",
                    dataFormat: value => {
                        return statusPayment( value ).status;
                    }
                },
                { field: "remark", label: "หมายเหตุ" },
                { field: "receipt", label: "เลขที่ใบเสร็จ" }
            ]
            return columns
        },
        filterDataTopUp(){
            let res = []
            if( this.filterStatus === null ){
                res = this.dataTopup
            }else{
                res = this.dataTopup.filter( detail => {
                    return String( detail.status ) === String( this.filterStatus )
                })
            }
            return res
        },
        footerTotal() {
            const total = {
                credit: 0,
            }
            this.dataTopup.forEach(item => {
                total.credit += +item.credit
            })

            return total;
        }
    }
};
</script>
